window.LoadProviderMap = function() {
    if (typeof locationStr === "undefined") return;

    var locations = JSON.parse(locationStr);
    
    if (locations.length === 0) return;

    if (typeof maplibregl === "undefined") {
      console.warn("MapLibre not yet loaded. Retrying...");
      return setTimeout(LoadProviderMap, 100); // retry after 100ms
    }

    const centerLat = locations[0][1];
    const centerLng = locations[0][2];
    const envId = window.freshpaintEnvironmentID;
    const styleName = 'standard-light';

    const styleUrl = `https://freshpaint-hipaa-maps.com/${envId}/${styleName}/style-descriptor`;

    const map = new maplibregl.Map({
        container: 'locationMap',
        style: styleUrl,
        center: [-98.5795, 39.8283], // fallback center (US center)
        zoom: 4,
        cooperativeGestures: true
      });

      map.addControl(new maplibregl.NavigationControl(), 'top-left');

      const bounds = new maplibregl.LngLatBounds();

      function fitToLocations() {
        if (locations.length === 1) {
          map.easeTo({ center: [parseFloat(locations[0][2]), parseFloat(locations[0][1])], zoom: 12 });
        } else {
          map.fitBounds(bounds, { padding: 60, maxZoom: 10 });
        }
      }

      const mapContainer = document.getElementById('locationMap');
      if (mapContainer && typeof ResizeObserver !== 'undefined') {
        // The map's container starts hidden inside a closed mobile accordion, so it
        // initializes at 0x0. Re-resize/re-fit whenever the container's real size
        // becomes available (e.g. the accordion is expanded).
        const resizeObserver = new ResizeObserver(() => {
          map.resize();
          fitToLocations();
        });
        resizeObserver.observe(mapContainer);
      }

      map.on('load', () => {
        if (!Array.isArray(locations) || !locations.length) {
            console.warn('No locations found.');
            return;
        }

        locations.forEach((item) => {
            const lat = parseFloat(item[1]);
            const lng = parseFloat(item[2]);
            const number = item[3];

            if (isNaN(lat) || isNaN(lng)) return;

            const el = document.createElement('div');
            el.className = 'numbered-marker';
            el.textContent = number;

            new maplibregl.Marker({ 
                element: el, 
                anchor: 'bottom',
                offset: [0, -8]
            })
            .setLngLat([lng, lat])
            .addTo(map);

            bounds.extend([lng, lat]);
        });

        fitToLocations();
    });

    return false;
}

//initMap();
